<template>
  <div v-loading="loading" class="formData">
    <div v-if="form">
      <!-- 申請資料 -->
      <FormBox
        :title="$t('hzmbChange.title.formData')"
        style="background: #fff"
      >
        <el-form
          :model="form"
          class="form_type1_box form_box"
          hide-required-asterisk
          label-position="top"
        >
          <el-row :gutter="86" type="flex" style="align-items: flex-start">
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.changeType')"
                prop="changeType"
                :rules="[
                  {
                    required: true,
                    message: $t('hzmbChange.message.notNull'),
                  },
                ]"
              >
                <el-select v-model="form.changeType" disabled>
                  <el-option
                    v-for="item in changeTypeOptions"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isGHCompany && form.hkRenewAllowed === 'Y'"
              :xs="24"
              :sm="12"
            >
              <el-form-item :label="$t('hzmbChange.label.renew')">
                <el-switch
                  v-model="form.renew"
                  :active-text="$t('hzmbChange.label.renewActive')"
                  class="renew-switch"
                  @change="onRenewChange"
                ></el-switch>
              </el-form-item>
              <div style="color: #5ba7ad">
                <span v-if="form.changeType === 'CHANGE_DRIVER'">
                  {{ $t("hzmbChange.message.changeTypeTips") }}
                </span>
                <span
                  v-if="
                    ['CHANGE_VEHICLE', 'CHANGE_VEHICLE_DRIVER'].includes(
                      form.changeType
                    )
                  "
                >
                  {{ $t("hzmbChange.message.changeTypeTips2") }}
                </span>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </FormBox>
      <!-- 配額人資料 -->
      <Quota
        ref="formQuota"
        :form="form"
        :applicantType="applicantType"
        :vssForm="vssForm"
      ></Quota>
      <!-- 車輛資料 -->
      <Vehicle
        v-if="hasChangeVehicle || form.changeType === 'CHANGE_DRIVER'"
        ref="formVehicle"
        :form="form"
      ></Vehicle>
      <!-- 駕駛人資料 -->
      <Drivers
        v-if="hasChangeDriver"
        ref="formDrivers"
        :form="form"
        :applicantType="applicantType"
      ></Drivers>
      <div class="next_btn">
        <p class="m-tempsave-tips">{{ $t("message.tempSave_tips") }}</p>
        <GradientBtn
          v-if="['meta', 'development'].includes(env)"
          @click="devMockData"
        >
          DEV一鍵賦值
        </GradientBtn>
        <GradientBtn :loading="submitLoading" @click="next">{{
          $t("hzmbChange.action.next_upload")
        }}</GradientBtn>
      </div>
    </div>
  </div>
</template>

<script>
import Quota from "./components/Application/Quota.vue";
import Vehicle from "./components/Application/Vehicle.vue";
import Drivers from "./components/Application/Drivers.vue";
import GradientBtn from "@/components/GradientBtn";
import HzmbVehDriApplicationChangeAPI from "@/api/HzmbVehDriApplicationChangeAPI";
import { getChangeTypeOptions } from "./options";
import FormBox from "../components/FormBox.vue";
export default {
  components: {
    Quota,
    Drivers,
    Vehicle,
    GradientBtn,
    FormBox,
  },
  data() {
    return {
      loading: false,
      id: this.$route.params.applicationId,
      form: null,
      vssForm: {
        spRemark: {},
      },
      submitLoading: false,
      env: process.env.VUE_APP_ENV,
    };
  },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    applicantType() {
      switch (this.serviceType) {
        case "HZMB_CHANGE_PERSON":
          return "PERSON";
        case "HZMB_CHANGE_COMP":
        case "HZMB_GH_CHANGE_COMP":
          return "COMPANY";
        default:
          return "";
      }
    },
    changeTypeOptions: getChangeTypeOptions,
    hasChangeVehicle() {
      const { changeType } = this.form;
      return ["CHANGE_VEHICLE", "CHANGE_VEHICLE_DRIVER"].includes(changeType);
    },
    hasChangeDriver() {
      const { changeType } = this.form;
      return ["CHANGE_DRIVER", "CHANGE_VEHICLE_DRIVER"].includes(changeType);
    },
    isCompany() {
      return ["HZMB_CHANGE_COMP", "HZMB_GH_CHANGE_COMP"].includes(
        this.serviceType
      );
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
    isChangeDriver() {
      return this.form.changeType === "CHANGE_DRIVER";
    },
  },
  methods: {
    async next() {
      let formQuota = this.$refs["formQuota"].validateForm();
      let formVehicle =
        !this.$refs["formVehicle"] || this.$refs["formVehicle"].validateForm();
      let formDrivers =
        !this.$refs["formDrivers"] || this.$refs["formDrivers"].validateForm();
      if (!(formQuota && formVehicle && formDrivers)) {
        this.$message({
          message: this.$t("hzmbChange.message.form_error"),
          type: "error",
        });
        return;
      }
      // 暫存
      let form = JSON.parse(JSON.stringify(this.form));
      form.language = this.$t("message.lang");
      delete form.quota.vssMacauAddress;
      // 駕駛人
      form.drivers = form.drivers.map((item) => {
        // 國籍處理
        item.drvNational = item.otherNationality
          ? item.otherNationalityText
          : item.drvNational;
        return item;
      });
      if (form.vehicle) {
        // 刪除車輛編號和車身後8位
        delete form.vehicle.regAndIdNo;
        // 內地車牌加上“粤”
        if (form.vehicle.plateNoCn)
          form.vehicle.plateNoCn = "粤" + form.vehicle.plateNoCn;
      }

      // 根據更換類型，刪減欄位
      if (form.changeType === "CHANGE_VEHICLE") {
        delete form.drivers;
      }

      // 未暫存過，去掉id
      if (!form.id) delete form.id;

      try {
        this.submitLoading = true;
        const { hzmbVehDriChangeApplication } =
          await HzmbVehDriApplicationChangeAPI.save(form);
        const { id } = hzmbVehDriChangeApplication;
        this.$router.push(`/hzmb-change-vd/${this.serviceType}/upload/${id}`);
      } catch (error) {
        this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    // 獲取暫存數據
    async get() {
      try {
        this.loading = true;
        let application = {};
        if (this.id) {
          const { hzmbVehDriChangeApplication } =
            await HzmbVehDriApplicationChangeAPI.findById(this.id);
          application = hzmbVehDriChangeApplication;
        } else {
          const serviceType = this.serviceType;
          const verifyForm =
            JSON.parse(localStorage.getItem("verifyForm")) || {};
          const data = await HzmbVehDriApplicationChangeAPI.check({
            ...verifyForm,
            serviceType,
          });
          application = data;
        }
        this.form = this.formatForm(application);
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    formatForm(application) {
      let resetForm = {
        quota: { macauAddress: {} },
        vehicle: {},
        drivers: [{}],
      };
      let quota = application.quota;
      if (quota) {
        // 電話去掉區號
        if (quota.mainlandPhone) {
          quota.mainlandPhone = quota.mainlandPhone.replace(/86-/g, "");
        }
        if (quota.hkPhone) {
          quota.hkPhone = quota.hkPhone.replace(/852-/g, "");
        }
        // 地址初始化
        if (!quota.macauAddress) quota.macauAddress = {};
        // 內地電郵確認欄位回顯
        if (quota.mainlandEmail)
          quota.confirmMainlandEmail = quota.mainlandEmail;
      }
      // 電話去掉區號
      let drivers = application.drivers;
      if (drivers && drivers.length > 0) {
        application.drivers = drivers.map((ele) => {
          if (ele.mainlandPhone) {
            ele.mainlandPhone = ele.mainlandPhone.replace(/86-/g, "");
          }
          if (ele.drvTempLicNoCnStartDate) {
            const drvTempDate = this.$formatDate(
              ele.drvTempLicNoCnStartDate,
              "yyyy-MM-dd"
            );
            if (drvTempDate !== ele.drvTempLicNoCnStartDate)
              ele.drvTempLicNoCnStartDate = null;
          }
          if (ele.drvTempLicNoCnEndDate) {
            const drvTempDate = this.$formatDate(
              ele.drvTempLicNoCnEndDate,
              "yyyy-MM-dd"
            );
            if (drvTempDate !== ele.drvTempLicNoCnEndDate)
              ele.drvTempLicNoCnEndDate = null;
          }
          return ele;
        });
      } else {
        const isE02F02 = this.isE02F02(application);
        application.drivers = [{}].map((e) => {
          if (isE02F02) e.mobileAreaCode = "853";
          return e;
        });
      }
      // 內地車牌去除“粤”
      let vehicle = application.vehicle;
      if (vehicle) {
        vehicle.regAndIdNo = vehicle.registrationNo;
        if (vehicle.plateNoCn) {
          vehicle.plateNoCn = vehicle.plateNoCn.replace(/(粤|粵)/g, "");
        }
      }
      resetForm = application;

      return resetForm;
    },
    devMockData() {
      if (
        ["HZMB_CHANGE_COMP", "HZMB_GH_CHANGE_COMP"].includes(this.serviceType)
      ) {
        this.$set(this, "form", {
          ...this.form,
          quota: {
            quotaRegistrationNo: "MT-66-62",
            applicantIdentType: "CO",
            applicantIdentNo: "72620359",
            applicantCname: "鄭達明",
            applicantEname: "CHENG TAT MING",
            applicantMobile: "62369338",
            macauAddress: { textCn: "ASDFGH" },
            applicantTel: "62369338",
            applicantEmail: "kun-hai.qiu.external@atos.net",
            mainlandPhone: "12312312",
            hkPhone: "12312312",
            hkAddress: "ASDFGH",
            companyIdentityType: "CO",
            companyBrNo: "72620359",
            companyNameCn: "asdf",
            vssMacauAddress: "other",
          },
          vehicle: {
            registrationNo: "152201",
            vehicleInsuranceNo: "mac123",
            vehicleInsuranceStartDate: "2023-08-01",
            vehicleInsuranceEndDate: "2024-07-31",
            vehicleInsuranceCompanyNoHk: "asdfasdf",
            vehicleInsuranceNoHk: "hk11111",
            vehicleInsuranceStartDateHk: "2023-08-01",
            vehicleInsuranceEndDateHk: "2024-07-31",
            plateNoCn: null,
            vehicleInsuranceNoCn: "cn23423",
            vehicleInsuranceStartDateCn: "2023-08-07",
            vehicleInsuranceEndDateCn: "2024-08-06",
            vehId: 152201,
            plateNo: "MT-66-62",
            vin: "JMYLECQ2AYU000245",
            vehType: "L",
            regAndIdNo: "152201",
          },
          drivers: [
            {
              drvEname: "ASDF",
              drvIdentNo: "12312312",
              drvBirthDate: "1980-01-08",
              drvGender: "M",
              drvNational: "CN",
              drvLicTypeMo: "A",
              drvLicNoMo: "12312312",
              drvMobile: "61231231",
              mainlandPhone: "123123",
            },
          ],
        });
      }
      if (this.serviceType === "HZMB_CHANGE_PERSON") {
        this.$set(this, "form", {
          ...this.form,
          quota: {
            macauAddress: {
              textCn: "ASDFASDF",
            },
            applicantIdentType: "BM",
            applicantIdentNo: "12345678",
            applicantCname: "測試",
            applicantEname: "TEST",
            birthday: "1980-01-07",
            applicantMobile: "61234567",
            vssMacauAddress: "other",
            mainlandPhone: "12312312",
            hkPhone: "123213",
            hkAddress: "123123123",
          },
          vehicle: {
            identificationNo: "1234",
            regAndIdNo: "aa1234",
            registrationNo: "aa1234",
            vehicleInsuranceNo: "123123",
            vehicleInsuranceStartDate: "2023-10-01",
            vehicleInsuranceEndDate: "2024-10-05",
            vehicleInsuranceCompanyNoHk: "123",
            vehicleInsuranceNoHk: "123",
            vehicleInsuranceStartDateHk: "2023-10-01",
            vehicleInsuranceEndDateHk: "2024-10-30",
            vehicleInsuranceNoCn: "123123",
            vehicleInsuranceStartDateCn: "2023-10-03",
            vehicleInsuranceEndDateCn: "2024-10-24",
          },
          drivers: [
            {
              drvAddress1: "ASDFASDF",
              drvCname: "測試",
              drvEname: "TEST",
              drvIdentNo: "12345678",
              drvBirthDate: "1980-01-07",
              drvMobile: "61234567",
              mainlandPhone: "12312312",
              mainlandEmail: null,
              drvGender: "M",
              drvNational: "CN",
              otherNationality: false,
              drvLicTypeMo: "A",
              drvLicNoMo: "123456",
            },
          ],
        });
      }
    },
    isE02F02(application) {
      const { hzmbSubtype } = application;
      return this.isGHCompany && ["E02", "F02"].includes(hzmbSubtype);
    },
    // 修改是否續期回調
    onRenewChange() {
      if (this.form.changeType === "CHANGE_DRIVER") {
        this.$set(this.form, "vehicle", {
          ...this.form.vehicle,
          vehicleInsuranceCompanyNoHk: null,
          vehicleInsuranceNoHk: null,
          vehicleInsuranceStartDateHk: null,
          vehicleInsuranceEndDateHk: null,
          plateNoCn: null,
          vehicleInsuranceNoCn: null,
          vehicleInsuranceStartDateCn: null,
          vehicleInsuranceEndDateCn: null,
        });
      }
    },
  },
  async created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
/deep/.renew-switch.el-switch {
  .el-switch__core {
    width: 80px !important;
    height: 40px;
    border-radius: 50px;
  }
  .el-switch__core::after {
    width: 36px;
    height: 36px;
  }
}
/deep/.renew-switch.el-switch.is-checked .el-switch__core::after {
  margin-left: -37px;
}
</style>

<style lang="scss">
.pub_btn {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  .el-button {
    margin-left: 16px;
  }
}
.macauAddress .el-input {
  margin-bottom: 22px;
}
.macauAddress .el-row .el-col:last-child .el-input {
  margin-bottom: 0;
}
/deep/.el-form .el-form-item__label {
  display: block;
  width: 100%;
  text-align: left;
}
.form_type1_box {
  max-width: 760px;
  margin: 24px auto;
}
.next_btn {
  .gradient_btn {
    width: 300px;
    max-width: 100%;
  }
}
.title-tips {
  color: #f40101;
  font-weight: normal;
  padding-left: 8px;
}
</style>
